<template>
  <el-dialog
    :model-value="visible"
    @update:model-value="$emit('update:visible', $event)"
    title="VIP兑换"
    width="400px"
    :close-on-click-modal="false"
    class="vip-redeem-dialog"
  >
    <el-form :model="form" @submit.prevent="handleRedeem">
      <el-form-item label="兑换码">
        <el-input
          v-model="form.code"
          placeholder="请输入VIP兑换码"
          :disabled="loading"
        />
      </el-form-item>
      
      <el-form-item>
        <el-button
          type="primary"
          :loading="loading"
          @click="handleRedeem"
          style="width: 100%"
        >
          立即兑换
        </el-button>
      </el-form-item>
    </el-form>

    <div class="vip-status" v-if="userInfo">
      <p>VIP等级：{{ userInfo.vip === 0 ? '普通用户' : `VIP${userInfo.vip}` }}</p>
      <p v-if="userInfo.vipExpiresAt">
        到期时间：{{ formatDate(userInfo.vipExpiresAt) }}
      </p>
    </div>
  </el-dialog>
</template>

<script lang="ts" setup>
import { ref, defineProps, defineEmits, watch } from 'vue';
import { ElMessage } from 'element-plus';
import { vipService } from '@/services/vipService';
import { useAuthStore } from '@/store/modules/auth';
import { useUserStore } from '@/store/modules/user';

const props = defineProps({
  visible: {
    type: Boolean,
    default: false
  }
});

const emit = defineEmits(['update:visible', 'redeemed']);

const authStore = useAuthStore();
const userStore = useUserStore();
const loading = ref(false);
const form = ref({
  code: ''
});

const userInfo = ref(null);

// 格式化日期
const formatDate = (dateString: string) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  return date.toLocaleDateString('zh-CN', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit'
  });
};

// 监听对话框显示状态
watch(() => props.visible, (newVal) => {
  if (newVal) {
    fetchUserInfo();
  }
});

// 获取用户信息
const fetchUserInfo = async () => {
  try {
    userInfo.value = userStore.userInfo;
    if (!userInfo.value) {
      await userStore.fetchUserInfo();
      userInfo.value = userStore.userInfo;
    }
  } catch (error) {
    console.error('获取用户信息失败:', error);
  }
};

// 处理兑换
const handleRedeem = async () => {
  if (!form.value.code) {
    ElMessage.warning('请输入兑换码');
    return;
  }

  loading.value = true;
  try {
    const response = await vipService.redeemVipCode(form.value.code);
    if (response.code === 200) {
      ElMessage.success('兑换成功');
      form.value.code = '';
      await userStore.fetchUserInfo(); // 刷新用户信息
      userInfo.value = userStore.userInfo;
      emit('redeemed');
      closeDialog(); // 关闭对话框
    } else {
      ElMessage.error(response.message || '兑换失败');
    }
  } catch (error: any) {
    ElMessage.error(error.message || '兑换失败');
  } finally {
    loading.value = false;
  }
};

// 关闭对话框
const closeDialog = () => {
  emit('update:visible', false);
};
</script>

<style scoped>
.vip-status {
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid #eee;
}

.vip-status h3 {
  margin-bottom: 10px;
  color: #409EFF;
}

.vip-status p {
  margin: 5px 0;
  color: #666;
}

/* 移动端适配 */
@media (max-width: 768px) {
  :deep(.el-dialog) {
    width: 90% !important;
    max-width: 400px;
    margin: 0 auto !important;
  }
  
  :deep(.el-dialog__body) {
    padding: 15px !important;
  }
  
  :deep(.el-dialog__header) {
    padding: 15px !important;
  }
  
  :deep(.el-form-item) {
    margin-bottom: 15px;
  }
}
</style> 